import {EditableLabel} from 'shells/editable-label/editable-label';

import type {PeepType} from '../../../types';

import styles from './peep-name-container.module.css';

interface Props {
    entityType: PeepType;
    value: string;
    onSaveNewValue: (value: string) => Promise<any>;
    isDeleted?: boolean;
}

export function PeepNameContainer(props: Props) {
    const placeholder = `Name this ${props.entityType === 'account' ? 'company' : 'person'}`;

    return (
        <div
            className={
                props.isDeleted ? styles['name-container--deleted'] : styles['name-container']
            }
        >
            <EditableLabel
                value={props.value}
                onSaveNewValue={props.onSaveNewValue}
                placeholder={placeholder}
                shouldTruncate={true}
            />
        </div>
    );
}
